export default __webpack_public_path__ + "static/background-header-6945433da21e57681a19f5b9830a41cb.png";